module.exports = __webpack_public_path__ + "img/godknows.b83daf2d.jpg";